import * as ActionTypes from '../actions'
import preval from 'preval.macro'

// Updates error message
export const errorMessage = (state = null, action) => {
  const { type, error } = action

  if (type === ActionTypes.RESET_ERROR_MESSAGE) {
    return null
  } else if (error) {
    return error
  }

  return state
}

// Set whether PayPal SDK script is loaded 
export const payPalSdkLoaded = (state = false, action) => {
	const { type, response } = action 
	
	if(type === ActionTypes.SET_PAYPAL_SDK_LOADED){
		return response;
	}
	
	return state;
}
export const payPalSdkError = (state = false, action) => {
	const { type, response } = action 
	
	if(type === ActionTypes.SET_PAYPAL_SDK_ERROR){
		return response;
	}
	
	return state;
}

export const timedOut = (state = false, action) => {
	const { type, response } = action 
	
	if(type === ActionTypes.SET_TIMED_OUT){
		return response;
	}
	
	return state;
}

export const timedOutLoggedOut = (state = false, action) => {
	const { type, response } = action 
	
	if(type === ActionTypes.SET_TIMED_OUT_LOGGED_OUT){
		return response;
	}
	
	return state;
}

export const apiSending = (state = 0, action) => {
	const {type, response} = action 
	
	if(type === ActionTypes.SET_SENDING){
		return response ? state + 1 : state - 1;
	}
	return state;
}

export const covidNoticeDismissed = (state = false, action) => {
	const {type, response} = action 
	
	switch(type){
		case 'SET_COVID_NOTICE_DISMISSED':
			return response;
		case 'LOGIN_SUCCESS':
		case 'LOGOUT_SUCCESS':
			return false;
		default:
			return state;
	}

}

export const generalNoticeDismissed = (state = false, action) => {
	const {type, response} = action 
	
	switch(type){
		case 'SET_GENERAL_NOTICE_DISMISSED':
			return response;
		case 'LOGIN_SUCCESS':
		case 'LOGOUT_SUCCESS':
			return false;
		default:
			return state;
	}

}

export const pdfFonts = (state = {
	Roboto: {
		normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.6/fonts/Roboto/Roboto-Regular.ttf',
		bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.6/fonts/Roboto/Roboto-Medium.ttf',
		italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.6/fonts/Roboto/Roboto-Italic.ttf',
		bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.6/fonts/Roboto/Roboto-MediumItalic.ttf'
	}	
}, action) => {
	return state;
}

const buildDate = preval`module.exports = new Date();`;
export const uMAS4MVersion = (state = {
	version: "1.10",
	date: buildDate
}, action) => {
	return state;
}